module.exports = import("/pathway-forms-ui/remoteEntry.js");